import styled from 'styled-components';

const PageBreakIcon = styled.span`
  display: block;
  width: 16px;
  height: 16px;
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    height: 5px;
    border: 1.5px solid currentColor;
    border-radius: 1px;
  }

  &::before {
    top: 0;
    border-bottom: 1.5px dashed currentColor;
  }

  &::after {
    bottom: 0;
    border-top: 1.5px dashed currentColor;
  }
`;

export default {
  PageBreakIcon,
};
